<template>
    <v-container fluid grid-list-sm>
        <v-layout row wrap>
            <v-flex xs12>
                <v-container fluid grid-list-sm class="pt-0">
                    <v-layout row wrap>
                        <v-flex xs8 v-show="selectedPriceList.Group === 'C.R.P.'">
                            <v-layout align-center justify-start row fill-height>
                                <h1 class="title font-weight-light pt-3 pl-1"><span class="primary--text f-b">{{ selectedCustomer.SN_ACCOUNT }}</span> {{ selectedCustomer.SN_NAME }}</h1>
                            </v-layout>
                        </v-flex>
                        <v-flex xs4 v-show="selectedPriceList.Group === 'C.R.P.'">
                            <v-layout align-center justify-end row fill-height>
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </v-layout>
                        </v-flex>
                        <v-flex xs8>
                            <v-form ref="fileForm" enctype="multipart/form-data" novalidate>
                                <upload-btn title="Select Excel file to upload" @file-update="onFileUpdate" accept=".xls,.xlsx">
                                    <template slot="icon-left">
                                        <v-icon left>folder_open</v-icon>
                                    </template>
                                </upload-btn>
                            </v-form>
                        </v-flex>
                        <v-flex xs4 text-xs-right>
                            <v-btn @click="onCancel">Cancel</v-btn>
                            <v-btn color="primary" type="submit" @click="onImport" :disabled="formIsValid<1">Start Import</v-btn>
                        </v-flex>
                        <v-flex xs3 style="max-width:300px">
                            <v-form ref="dataForm" @submit.prevent="submit" class="pt-0">
                                <v-container grid-list-sm class="pt-0">
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                            <!-- <v-select label="Price List Type" v-model="item.Type" :items="priceListOptions" required :rules="rules.type"></v-select> -->
                                            <v-text-field label="Price List Group" v-model="item.Group" disabled persistent-hint hint="Price list type (pre-selected)"></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 v-show="selectedPriceList.Group !== 'C.R.P.'">
                                            <v-text-field label="Price List" v-model="selectedPriceList.Name" disabled persistent-hint hint="Price list (pre-selected)"></v-text-field>
                                        </v-flex>
                                        <v-flex xs11>
                                            <!-- <v-select label="Publish Date" v-model="item.Meta.Dt" :items="columnList" item-text="Name" item-value="_id" clearable></v-select> -->
                                            <v-text-field label="Publish Date" v-model="item.Meta.Dt" clearable persistent-hint hint="Cell reference e.g. B13"></v-text-field>
                                        </v-flex>
                                        <v-flex xs1 :class="color.Dt"></v-flex>
                                        <v-flex xs11>
                                            <v-text-field label="Special Note" v-model="item.Meta.SpecialNote" clearable persistent-hint hint="Cell reference e.g. B13"></v-text-field>
                                        </v-flex>
                                        <v-flex xs1 :class="color.SpecialNote"></v-flex>
                                        <v-flex xs11>
                                            <v-select label="Item Number" v-model="item.Meta.Item" :items="columnList" item-text="Name" item-value="_id" required :rules="rules.item"></v-select>
                                        </v-flex>
                                        <v-flex xs1 :class="color.Item"></v-flex>
                                        <v-flex xs11>
                                            <v-select label="Description" v-model="item.Meta.Desc" :items="columnList" item-text="Name" item-value="_id" required :rules="rules.desc"></v-select>
                                        </v-flex>
                                        <v-flex xs1 :class="color.Desc"></v-flex>
                                        <v-flex xs11>
                                            <v-select label="Unit" v-model="item.Meta.Unit" :items="columnList" item-text="Name" item-value="_id" required :rules="rules.unit"></v-select>
                                        </v-flex>
                                        <v-flex xs1 :class="color.Unit"></v-flex>
                                        <v-flex xs6>
                                            <v-select label="Price" v-model="item.Meta.Price" :items="columnList" item-text="Name" item-value="_id" required :rules="rules.price"></v-select>
                                        </v-flex>
                                        <v-flex xs5>
                                            <v-text-field label="Title" v-model="item.Meta.PriceTitle" clearable></v-text-field>
                                        </v-flex>
                                        <v-flex xs1 :class="color.Price"></v-flex>
                                        <v-flex xs6>
                                            <v-select label="Price 2" v-model="item.Meta.Price2" :items="columnList" item-text="Name" item-value="_id" required></v-select>
                                        </v-flex>
                                        <v-flex xs5>
                                            <v-text-field label="Title" v-model="item.Meta.Price2Title" clearable></v-text-field>
                                        </v-flex>
                                        <v-flex xs1 :class="color.Price2"></v-flex>
                                        <v-flex xs11>
                                            <v-select label="Comment" v-model="item.Meta.Comm" :items="columnList" item-text="Name" item-value="_id" clearable></v-select>
                                        </v-flex>
                                        <v-flex xs1 :class="color.Comm"></v-flex>
                                        <v-flex xs11>
                                            <v-select label="JMP Reference" v-model="item.Meta.Jmp" :items="columnList" item-text="Name" item-value="_id" clearable></v-select>
                                        </v-flex>
                                        <v-flex xs1 :class="color.Jmp"></v-flex>
                                        <v-flex xs11>
                                            <v-select label="Opera Reference" v-model="item.Meta.Opera" :items="columnList" item-text="Name" item-value="_id" clearable></v-select>
                                        </v-flex>
                                        <v-flex xs1 :class="color.Opera"></v-flex>
                                        <v-flex xs11>
                                            <v-select label="Additionl Info" v-model="item.Meta.Add" :items="columnList" item-text="Name" item-value="_id" clearable></v-select>
                                        </v-flex>
                                        <v-flex xs1 :class="color.Add"></v-flex>
                                        <v-flex xs12>
                                            <v-numeric label="Data Row Start" v-model="item.Meta.RowStart" required :rules="rules.rowstart"></v-numeric>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-numeric label="Data Row End" v-model="item.Meta.RowEnd" required :rules="rules.rowend"></v-numeric>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-flex>
                        <v-flex xs9>
                            <table class="data-tbl">
                                <tr>
                                    <td class="gutter">&nbsp;</td>
                                    <td class="gutter" v-for="col in columnList" v-bind:key="col._id">
                                        {{ col.Name }}
                                    </td>
                                </tr>
                                <tr v-for="row in fileData.rows" v-bind:key="row.idx" v-show="!row.hidden">
                                    <td class="gutter">{{ row.idx }}</td>
                                    <td v-for="(col, i) in row.cols" v-bind:key="i" :class="getClass(row.idx, i)">
                                        {{ col }}
                                    </td>
                                </tr>
                            </table>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
        <v-dialog v-model="isDialogBusy" persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    Processing...
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import UploadButton from 'vuetify-upload-button';
import Numeric from '../../controls/Numeric';

export default {
    name: 'PriceImport',
    components: {
        'v-numeric': Numeric,
        'upload-btn': UploadButton
    },
    props: {},
    data() {
        return {
            title: 'Price List Import',
            user: { has: () => 0 },
            ViewCompany: {},
            selectedCustomer: {},
            selectedPriceList: {},
            isBusy: false,
            isDialogBusy: false,
            item: {
                Meta: {
                    Dt: '',
                    Item: '',
                    Desc: '',
                    Unit: '',
                    Price: '',
                    PriceTitle: '',
                    Price2: '',
                    Price2Title: '',
                    Comm: '',
                    Jmp: '',
                    Opera: '',
                    Add: '',
                    RowStart: '',
                    RowEnd: '',
                    SpecialNote: '',
                }
            },
            color: {
                Dt: 'teal lighten-5',
                Item: 'pink lighten-5',
                Desc: 'green lighten-5',
                Unit: 'indigo lighten-5',
                Price: 'blue lighten-5',
                Price2: 'blue-grey lighten-5',
                Comm: 'lime lighten-5',
                Jmp: 'cyan lighten-5',
                Opera: 'purple lighten-5',
                Add: 'orange lighten-5',
                SpecialNote: 'blue-grey lighten-5',
            },
            // priceListOptions: ['C.R.P.', 'Rubber', 'Sponge', 'I.G.M.', 'Metal', 'Mining', 'Other'],
            columnList: [
                { _id: 1, Name: 'A' },
                { _id: 2, Name: 'B' },
                { _id: 3, Name: 'C' },
                { _id: 4, Name: 'D' },
                { _id: 5, Name: 'E' },
                { _id: 6, Name: 'F' },
                { _id: 7, Name: 'G' },
                { _id: 8, Name: 'H' },
                { _id: 9, Name: 'I' },
                { _id: 10, Name: 'J' },
                { _id: 11, Name: 'K' },
                { _id: 12, Name: 'L' },
                { _id: 13, Name: 'M' },
                { _id: 14, Name: 'N' },
            ],
            rules: {
                type: [val => (val || '').length > 0 || 'This field is required'],
                item: [val => (val || -1) >= 0 || 'This field is required'],
                desc: [val => (val || -1) >= 0 || 'This field is required'],
                unit: [val => (val || -1) >= 0 || 'This field is required'],
                price: [val => (val || -1) >= 0 || 'This field is required'],
                rowstart: [val => val > 1 || 'This field is required and a number'],
                rowend: [val => val > 1 || 'This field is required and a number'],
                // rowstart: [val => val < 10 || `I don't believe you!`],
                // rowend: [val => val < 10 || `I don't believe you!`],
            },
            fileSelected: null,
            fileData: { rows: [] }
        };
    },
    mounted() {
        this.$root.$on('CompanySwitched', () => {
            this.ViewCompany = this.$ls.get('ViewCompany', {});
            this.loadData();
        });

        this.user = this.$ls.get('User');
        Object.defineProperty(this.user, 'has', { value: this.$has });
        this.ViewCompany = this.$ls.get('ViewCompany', {});
        this.selectedCustomer = this.ContextCustomer;
        this.selectedPriceList = this.$route.query.selectedPriceList || { Group: 'C.R.P.' };
        this.loadData();
    },
    computed: {
        formIsValid() {
            const v =
                this.item.Group &&
                // this.item.Meta.Dt &&
                this.item.Meta.Item &&
                this.item.Meta.Desc &&
                this.item.Meta.Unit &&
                this.item.Meta.Price &&
                this.item.Meta.RowStart &&
                this.item.Meta.RowEnd;
            return v || 0;
        }
    },
    methods: {
        async loadData() {
            try {
                this.isBusy = true;
                const response = await this.$http.post('/PriceList/list', { C_Id: this.ViewCompany._id, CU_Id: this.selectedCustomer._id, Group: this.selectedPriceList.Group, Type: this.selectedPriceList._id });
                this.item = response.data.d.length
                    ? response.data.d[0]
                    : { C_Id: this.ViewCompany._id, CU_Id: this.selectedCustomer._id, Group: this.selectedPriceList.Group, Type: this.selectedPriceList._id, Meta: {} };
                this.isBusy = false;
            }
            catch (err) {
                console.error(err);
                this.$alert({ type: 'error', title: 'Data Error', message: 'An error occurred fetching the data.' });
            }
        },
        getClass(r, c) {
            const name = this.getCellName(r - 1, c);
            const cC = c + 1;
            if (name === this.item.Meta.Dt) return this.color.Dt;
            if (name === this.item.Meta.SpecialNote) return this.color.SpecialNote;
            if (r >= this.item.Meta.RowStart && r <= this.item.Meta.RowEnd) {
                if (cC === this.item.Meta.Desc) return this.color.Desc;
                if (cC === this.item.Meta.Item) return this.color.Item;
                if (cC === this.item.Meta.Desc) return this.color.Desc;
                if (cC === this.item.Meta.Unit) return this.color.Unit;
                if (cC === this.item.Meta.Price) return this.color.Price;
                if (cC === this.item.Meta.Price2) return this.color.Price2;
                if (cC === this.item.Meta.Comm) return this.color.Comm;
                if (cC === this.item.Meta.Jmp) return this.color.Jmp;
                if (cC === this.item.Meta.Opera) return this.color.Opera;
                if (cC === this.item.Meta.Add) return this.color.Add;
            }
            return '';
        },
        // > Returns the column name from the number e.g. 27 will return 'AA'.
        getColName(col) {
            let name = '';
            for (++col; col; col = Math.floor((col - 1) / 26)) {
                name = String.fromCharCode(((col - 1) % 26) + 65) + name;
            }
            return name;
        },
        /**
         * Converts an Excel serial number date to a JS date.
         *
         * @param {any} serial Excel number date.
         * @returns JS Date.
         */
        dateXlToJs(serial) {
            const utcDays = Math.floor(serial - 25569);
            const utcValue = utcDays * 86400;
            const dateInfo = new Date(utcValue * 1000);
            const fractionalDay = serial - (Math.floor(serial) + 0.0000001);
            let totalSeconds = Math.floor(86400 * fractionalDay);
            const seconds = totalSeconds % 60;

            totalSeconds -= seconds;

            const hours = Math.floor(totalSeconds / (60 * 60));
            const minutes = Math.floor(totalSeconds / 60) % 60;

            return new Date(dateInfo.getFullYear(), dateInfo.getMonth(), dateInfo.getDate(), hours, minutes, seconds);
        },
        // > Constructs a cell name from the given row and column indexes.
        getCellName(row, col) {
            return this.getColName(col) + (row + 1);
        },
        async onFileUpdate(file) {
            try {
                if (!file) return;
                // let formData = new FormData(this.$refs.fileForm.$el);
                const formData = new FormData();
                this.isDialogBusy = true;
                const fileName = file.name;
                if (fileName.indexOf(this.selectedCustomer.SN_ACCOUNT) === -1 && this.selectedPriceList.Group === 'C.R.P.') {
                    this.$alert({ type: 'orange', title: 'Warning!', message: 'The file does not seem to match the customer. Please make sure this is the correct file before continuing.' });
                }
                formData.append('file', file, fileName);
                formData.append('maps', this.Meta);
                const response = await this.$http.post('/PriceList/pre-file', formData);
                if (response.data.s) {
                    this.fileData = response.data.d;
                    this.item.file = this.fileData.file;
                    this.item.Meta = this.fileData.maps;
                }
                else {
                    this.fileData = [];
                    this.$alert({ type: 'error', title: 'Upload Error', message: response.data.m });
                }
                this.isDialogBusy = false;
            }
            catch (err) {
                this.isDialogBusy = false;
                console.error(err);
                this.$alert({ type: 'error', title: 'Upload Error', message: 'An error occurred while loading the file.' });
            }
        },
        async onImport() {
            try {
                this.isDialogBusy = true;
                this.item.C_Id = this.ViewCompany._id;
                const response = await this.$http.post('/PriceList/load-file', this.item);
                if (response.data.s) {
                    this.$router.go(-1);
                    // this.$router.push({ path: 'PriceList' });
                }
                else {
                    this.$alert({ type: 'error', title: 'Import Error', message: response.data.m });
                }
                this.isDialogBusy = false;
            }
            catch (err) {
                this.isDialogBusy = false;
                console.error(err);
                this.$alert({ type: 'error', title: 'Import Error', message: 'An error occurred while importing the file.' });
            }
        },
        onCancel() {
            window.history.back();
        }
    }
};
</script>

<style lang="scss" scoped>
.upload-btn {
    padding-left: 5px;
}
.data-tbl {
    border: 1px solid #CCC;
    border-right: 0;
    border-bottom: 0;
    border-spacing: 0;
    border-collapse: separate;
}
.data-tbl .gutter {
    background-color: #DDD;
    color: #333;
    text-align: center;
}
.data-tbl td {
    border: 1px solid #CCC;
    border-top: 0;
    border-left: 0;
    padding: 2px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/PriceList/PriceListImport.vue